import { Modal, SafeAreaView, StyleProp, StyleSheet, Text, TextStyle, TouchableOpacity, View } from "react-native"
import { color_333333 } from "../assets/style/colors"
import { Str_Album, Str_Camera, Str_Cancel } from "../language/string_res"

interface SelectPhotoProps {
    visible: boolean,
    close: () => void
    text1: string
    text2: string
    textStyle1?: StyleProp<TextStyle>
    textStyle2?: StyleProp<TextStyle>
    click1?: () => void
    click2?: () => void
    animationType?: 'none' | 'slide' | 'fade'
}

export const CommonBottomModal = ({
    visible, text1, text2,
    close, click1, click2, textStyle1,
    textStyle2, animationType }: SelectPhotoProps) => {

    return (<Modal
        animationType={animationType ? animationType : "fade"}
        transparent={true}
        statusBarTranslucent={true}
        visible={visible}
        onRequestClose={close}>
        <TouchableOpacity
            style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.5)" }}
            activeOpacity={1}
            onPress={close}>
            <SafeAreaView
                style={styles.modalContainer}>
                <TouchableOpacity
                    style={styles.modalItemContainer}
                    onPress={() => {
                        click1?.()
                    }}>
                    <Text style={[styles.modalText, textStyle1]}>{text1 || Str_Album}</Text>
                </TouchableOpacity>
                <View style={{ backgroundColor: "#F1F1F1", height: 0.5, marginHorizontal: 9 }} />
                <TouchableOpacity
                    style={styles.modalItemContainer}
                    onPress={() => {
                        click2?.()
                    }}>
                    <Text style={[styles.modalText, textStyle2]}>{text2 || Str_Camera}</Text>
                </TouchableOpacity>
                <View style={{ backgroundColor: "#F7F7F7", height: 6 }} />
                <TouchableOpacity
                    style={styles.modalItemContainer}
                    onPress={close}>
                    <Text style={styles.modalText}>{Str_Cancel}</Text>
                </TouchableOpacity>
            </SafeAreaView>
        </TouchableOpacity>
    </Modal>);
};


const styles = StyleSheet.create({
    modalText: {
        fontSize: 18,
        color: color_333333
    },
    modalItemContainer: {
        alignItems: "center",
        justifyContent: "center",
        paddingVertical: 16
    },
    modalContainer: {
        position: "absolute",
        width: "100%",
        backgroundColor: "white",
        borderTopEndRadius: 15,
        borderTopStartRadius: 15,
        bottom: 0
    }

})